import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MovementOrderVehicleStrategy, Vehicle, VehicleSelection } from '../../movement-orders.model';
import { AppServerAPI } from '@sdbn/common';

@Component({
  selector: 'app-moving-order-vehicle-selection',
  templateUrl: './moving-order-vehicle-selection.component.html',
  styleUrls: ['./moving-order-vehicle-selection.component.scss']
})
export class MovingOrderVehicleSelectionComponent implements OnInit {

  dataSource = new MatTableDataSource(new Array<Vehicle>());

  @Input() vehicleStrategy: MovementOrderVehicleStrategy;
  @Output() selectedVehicle = new EventEmitter<number>();

  defaultVisibleColumns = [
    'scope', 'carrier', 'identifier', 'name', 'currentStation'
  ];

  columnsToDisplay = this.defaultVisibleColumns;

  sortColumn = 'start';

  sortDirection: SortDirection = 'asc' as SortDirection;

  selectedListEntry: Vehicle;

  constructor(
    private appServerAPI: AppServerAPI
  ) { }

  ngOnInit(): void {
    this.loadVehicles();
  }

  public sortChanged(event) {
  }

  getRowStyles(transport: any): string { return ''; }

  toggleSelection(vehicle: any) {
    this.selectedListEntry = vehicle;
    this.selectedVehicle.next(vehicle.id);
  }

  loadVehicles() {

    const selection: VehicleSelection = {
      vehicleStrategy: this.vehicleStrategy
    }

    this.appServerAPI.execute<any[]>(`/client/control/movement-orders/find-vehicles`, selection).subscribe(
      vehicles => {

        let data = new Array<Vehicle>();

        for (const vehicle of vehicles) {
          data.push(new Vehicle(vehicle));
        }

        this.dataSource = new MatTableDataSource(data);

      }
    );

  }

}
